// extracted by mini-css-extract-plugin
export default {"title":"FtfKn6cHkQKNhOHRQSDq"};